import { Dropdown } from "primereact/dropdown";
import { JVDate } from "../../../shared/JVDate";
import { JVDropdown } from "../../../shared/JVDropdown";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { IBranchMastDropdown, ICompanyMastDropdown, IUsersDropdown } from "../../../models/IDropdown";
import { Fetch } from "../../../shared/Fetch";
import { ILogin } from "../../../models/Login";
import { useForm } from "react-hook-form";

interface IProps {
    filter: IFilter,
    setFilter: (filter: IFilter) => void,
}

export interface IFilter {
    fromDate?: Date,
    toDate?: Date,
    trainer?: number;
    company?: number | null,
    branch?: number | null,
}

export const EmptyFilter: IFilter = {
    fromDate: new Date,
    toDate: new Date,
    trainer: 0,
    company: null,
    branch: null,
}

export const Filter = (props: IProps) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [selectedUsers, setSelectedUsers] = useState<any | null>(null);

    const { control, handleSubmit, reset, watch } = useForm<IFilter>({
        defaultValues: EmptyFilter,
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        let endPoint = loginObj.id === 1346 ? "allBranches" : "reqBranchList";
        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    };

    const loadCompanies = async () => {
        let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList";
        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    };

    const loadSm = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        let type = "";
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
            type = "branch";
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
            type = "comp";
        }
        const endPoint = "users";
        const response = await Fetch(`CarnivalTraining/${endPoint}`, "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }

    const searchToDB = async (body: IFilter) => {
        let filterData: any = body;
        let emptyFilter: any = EmptyFilter;

        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setFilter(body);
    }

    function onSubmit(data: IFilter) {
        searchToDB(data);
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company") {
                if (value.company != 0 && value.company != null) {
                    loadSm(0, value.company, 0);
                    loadBranches(value.company);
                } else {
                    if (value.company === 0 && value.company != null) {
                        loadBranches();
                        loadSm(control._formValues.branch, value.company, control._formValues.team);
                    }
                }
            }

            if (name === "branch") {
                if (value.branch != 0 && value.branch != null) {
                    loadSm(value.branch, 0, 0);
                } else {
                    if (value.branch === 0 && value.branch != null) {
                        loadSm(value.branch, control._formValues.company, control._formValues.team);
                    }
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);



    useEffect(() => {
        loadSm(0, 0, 0);
        loadCompanies();
        loadBranches();
    }, []);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            {/* <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" /> */}
            {/* <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" /> */}
            <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            <JVDropdown column={6} label="Branch" control={control} name="branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />
            <JVDropdown column={6} label="Users" control={control} name="trainer" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Trainer" />
            
            <div style={{ margin: '10px 0', width: '100%' }}></div>
            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyFilter); setSelectedUsers([]); }} type="button"></Button>
            </div>
        </form>
    );
}